import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import ExamesPage from './exames/ExamesPage'
import MedicamentosPage from './medicamentos/MedicamentosPage'
import AuditoriaPage from './auditoria/AuditoriaPage'
import TelekitsPage from './telekits/TelekitsPage'
import DispositivosPage from './dispositivos/DispositivosPage'
import FornecedoresPage from './fornecedores/FornecedoresPage'
import ModelosPage from './modelos/ModelosPage'
import LogsPage from './logs/LogsPage'
import ProfissionaisPage from './profissionais-saude/ProfissionaisPage'
import GruposPage from './grupos/GruposPage'
import UsuariosPage from './usuarios/UsuariosPage'
import TermosPage from '../termos/TermosPage'
import ParametrosPage from './parametros/ParametrosPage'
import NotasVersaoPage from '../notas-versao/NotasVersaoPage'

const AdminPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path='medicamentos/*' element={<MedicamentosPage />} />
        <Route path='exames/*' element={<ExamesPage />} />
        <Route path='exportar/*' element={<AuditoriaPage />} />
        <Route path='telekits/*' element={<TelekitsPage />} />
        <Route path='dispositivos/*' element={<DispositivosPage />} />
        <Route path='fornecedores/*' element={<FornecedoresPage />} />
        <Route path='modelos/*' element={<ModelosPage />} />
        <Route path='logs/*' element={<LogsPage />} />
        <Route path='profissionais-saude/*' element={<ProfissionaisPage />} />
        <Route path='grupos/*' element={<GruposPage />} />
        <Route path='usuarios/*' element={<UsuariosPage />} />
        <Route path='termos/*' element={<TermosPage />} />
        <Route path='parametros' element={<ParametrosPage />} />
        <Route path='notas-versao/*' element={<NotasVersaoPage />} />
      </Route>
      <Route index element={<Navigate to='/apps/admin/medicamentos' />} />
    </Routes>
  )
}

export default AdminPage
